import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=09fdb2de"
import script from "./ViewDocument.vue?vue&type=script&lang=ts"
export * from "./ViewDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports